<div [ngClass]="{'file-row': true, row: true, odd: oddRow}">
  <div class="col-lg-6">
    <span class="name">{{ fileObject.file.name}}
      <!-- <div *ngIf="disablefileupload"> -->
      <i class="fa fa-remove" style="font-size:15px;" (click)="deleteFile()" *ngIf="disablefileupload" data-cy="remove-file"></i>
      <!-- </div> -->
    </span>
    <div class="alert alert-danger" *ngIf="!fileObject.isValid" data-cy="error-message">
      {{ errorMessage }}
    </div>
  </div>

  <!-- <span style="float:right;">
    <span
      [ngClass]="{'text-primary':fileStatus ==='Uploading' ,'text-success': fileStatus === 'Uploaded','text-danger':fileStatus === 'Failed'}">
    <strong>  {{fileStatus}}</strong>
    </span>
  </span> -->

  <span style="float:right;">
    <span [ngClass]="{'text-primary': fileObject.status === FileObjectStatus.Uploading, 'text-success': fileObject.status === FileObjectStatus.Uploaded,
       'text-danger': fileObject.status === FileObjectStatus.Failed}">
      <strong *ngIf="fileObject.status !== FileObjectStatus.NotStarted"
        [ngClass]="{'error': fileObject.status === FileObjectStatus.Failed}" data-cy="upload-status">
        {{FileObjectStatus[fileObject.status]}}
      </strong>
    </span>
  </span>
  <strong class="error text-danger">{{uploadError}}</strong>


</div>